export class ParentAtom {}
